import { TDay } from './api/getMenu/types';
import justEatLogo from './assets/images/justeat-logo.svg';
import uberEatsLogo from './assets/images/ubereats-logo.png';
import deliverooLogo from './assets/images/deliveroo-logo.png';

export const PRICE_SCHEME_ID = 'price-scheme-id';
export const CHANNEL_FILTER_KEY = 'channel-filter';
export const PRICE_BAND_FILTER_KEY = 'price-band-filter';
export const GLOBAL_ITEM_UPDATE_NOTE =
  'Quick note: Whenever you update a product, these changes will show up in every place it’s used. This includes all menus, bundles and modifier groups.';
export const DAYS: TDay[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
export const WEEKDAYS: TDay[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
export const WEEKENDS: TDay[] = ['SATURDAY', 'SUNDAY'];
export const BANNER_MONTH_EXPIRY_TIME = 1;
export const BANNER_COOKIE_NAME = 'warning-banner';
export const NO_INVENTORY_TYPES = ['BUNDLE', 'NON-FOOD'];
export const SYNC_MESSAGE_TEXT = ['new', 'updated', 'removed'];
export const DEBOUNCE_DURATION = 300;
export const INFINITE_SCROLL_FETCH_THRESHOLD_PX = 1000;
export const MAX_NOTIFICATIONS = 3;
export const PRICING_FORM_ID = 'pricing-form';
export const SUPPORT_TICKET_URL = 'https://weareopenr.atlassian.net/servicedesk/customer/portal/1/group/1/create/1';
export const PRICING_TABLE_OPTIONS_CONTAINER_ID = 'pricing-table-options-container';

export const FEATURE_FLAGS = {
  PRICING_RULES: 'pricing-rules',
  ENHANCED_SCHEDULING: 'enhanced_scheduling',
  PRODUCT_PUBLISH_FLOW: 'product_publish_flow',
  INDEPENDENT_OPTION_GROUPS: 'independent_option_groups',
  NEW_DASHBOARD: 'new_dashboard',
  TIMETABLES: 'timetables',
  MENU_SETS: 'menu-sets',
  DEPOSIT_RETURN_SCHEME: 'deposit_return_scheme',
  MENU_ITEM_DRAG_AND_DROP: 'menu_item_drag_and_drop',
  ITEM_SEARCH_V2: 'item_search_v2',
} as const;

export enum EntitySource {
  LIBRARY = 'library',
  RANGES = 'ranges',
}

export enum ItemType {
  NON_FOOD = 'NON-FOOD',
  BUNDLE = 'BUNDLE',
  STANDARD = 'STANDARD',
  MODIFIER = 'MODIFIER',
}

export enum OptionGroupType {
  BUNDLE = 'BUNDLE',
  MODIFIER = 'MODIFIER',
}

export const ExternalSystemImages = {
  'Just Eat': justEatLogo,
  'Uber Eats': uberEatsLogo,
  Deliveroo: deliverooLogo,
};

export enum IntegrationType {
  DELIVERY_SERVICE = 'Delivery Service',
  POINT_OF_SALE_MANAGEMENT = 'Point of Sale Management',
  VENUE_MANAGEMENT = 'Venue Management',
  RECIPE_MANAGEMENT = 'Recipe Management',
  DESIGN_PLATFORM = 'Design Platform',
}

export const downStreamExternalSystemIntegrationTypes: IntegrationType[] = [
  IntegrationType.DELIVERY_SERVICE,
  IntegrationType.POINT_OF_SALE_MANAGEMENT,
  IntegrationType.DESIGN_PLATFORM,
];

export const PromptActions = {
  DELETE: 'Delete',
  CANCEL: 'Cancel',
};

export const REGULATORY_STATEMENTS = {
  HFSS: {
    code: 'HFSS',
    name: 'HFSS',
    displayName: 'High Fat, Salt or Sugar',
  },
  AGE_VERIFICATION: {
    code: 'AGE_VERIFICATION',
    name: 'Age Verification',
    displayName: 'Age Verification',
  },
} as const;

export const routerFutureFlags = { v7_startTransition: true, v7_relativeSplatPath: true };
